import { put, take, takeEvery } from 'redux-saga/effects';
import { consts as acceptJoinRequest } from '../acceptJoinRequest';
import { consts as declineJoinRequest } from '../declineJoinRequest';
import { consts as acceptInvitation } from '../acceptInvitation';
import { consts as declineInvitation } from '../declineInvitation';

import {
  actions as communitiesJoinReqsActions,
  paginatedActions as paginatedJoinReqsActions,
} from '../communitiesJoinRequests';
import { actions as notificationCounterActions } from '../notificationCounters';
import { ACTIVITY_TYPES } from '../../../constants';

const { JOIN_REQUESTS, MEMBER_INVITATIONS } = ACTIVITY_TYPES;

const mapTypes = {
  [acceptJoinRequest.SEND]: {
    type: JOIN_REQUESTS,
    SUCCESS_ACTION: acceptJoinRequest.SUCCEED,
  },
  [declineJoinRequest.SEND]: {
    type: JOIN_REQUESTS,
    SUCCESS_ACTION: declineJoinRequest.SUCCEED,
  },
  [acceptInvitation.SEND]: {
    type: MEMBER_INVITATIONS,
    SUCCESS_ACTION: acceptInvitation.SUCCEED,
  },
  [declineInvitation.SEND]: {
    type: MEMBER_INVITATIONS,
    SUCCESS_ACTION: declineInvitation.SUCCEED,
  },
};

function* handleJoinRequestsWorker({ type: actionType, payload }) {
  const { id } = payload;
  const { type, SUCCESS_ACTION } = mapTypes[actionType];

  yield put(communitiesJoinReqsActions.disableRequest({ id, type }));
  yield take(SUCCESS_ACTION);
  yield put(communitiesJoinReqsActions.removeRequest({ id, type }));
  yield put(paginatedJoinReqsActions.loadNextRequests({ limit: 1, type }));
  yield put(notificationCounterActions.updateActivityCount(-1));
}

export default function* handleJoinRequestsSaga() {
  yield takeEvery(
    [
      acceptJoinRequest.SEND,
      declineJoinRequest.SEND,
      acceptInvitation.SEND,
      declineInvitation.SEND,
    ],
    handleJoinRequestsWorker,
  );
}



// WEBPACK FOOTER //
// ./src/redux/communities/sagas/handleJoinRequests.js